<template>
  <div class="home">
    <div class="home-header">
      <div class="home-header-content">
        <div class="home-header-title">全网商机，一键掌握</div>
        <search-box
          :tab-switch-attrs="{ normalColor: '#fff', fontSize: '16px' }"
          style="width: 640px"
          show-tab
          @search="handleSearch"
        />
      </div>
    </div>
    <div class="home-body">
      <!-- 关注的项目动态 -->
      <div v-if="false" class="follow-project-block card body-width m-t-16">
        <div v-if="showGlossy" class="g-glossy">
          <!-- 如果未登录 -->
          <div v-if="!isLogin" class="login-tip-wrap">
            <div class="tip m-b-16">登录查看我关注的项目最新动态</div>
            <a-button type="primary" style="width: 120px" @click="login">
              立即登录
            </a-button>
          </div>
          <!-- 如果已登录但是非会员(没有会员权益或者会员已过期) -->
          <div v-else-if="showVipGlossy" class="vip-tip-wrap">
            <div class="tip m-b-16">
              开通高级会员，自动获得已关注项目关键内容提醒！
            </div>
            <div class="vip-button" @click="handleVipBuy">立即开通</div>
          </div>
        </div>
        <div class="flex row-between m-b-16">
          <div class="follow-project-block-title">我关注的项目最新动态</div>
          <div class="more-button" @click="toFollowProject">
            查看更多
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <common-empty v-if="followProjectList.length === 0" />
        <ul v-else>
          <li v-for="item in followProjectList" :key="item.projectId">
            <span
              class="follow-title text-ellipsis"
              @click="toProjectDetail(item)"
            >
              {{ item.purchaseName }}
            </span>
            <span
              v-if="item.noticeVo.noticeType"
              class="notice-tag"
              :class="`notice-tag--${
                getNoticeTypeEntry(item.noticeVo.noticeType).type
              }`"
            >
              {{
                getNoticeTypeEntry(item.noticeVo.noticeType).dynamicLabel || '-'
              }}
            </span>
          </li>
        </ul>
      </div>
      <!-- 最新公告信息 -->
      <div class="notice-block card">
        <div class="notice-block-title">最新公告信息</div>
        <!-- 未登录时，显示锁定内容 -->
        <!--<div-->
        <!--  v-if="!isLogin"-->
        <!--  class="notice-lock m-t-64 flex flex-column col-center"-->
        <!--&gt;-->
        <!--  <img-->
        <!--    style="width: 160px; height: 120px"-->
        <!--    :src="require('@/assets/images/home/home-notice-lock.png')"-->
        <!--    alt=""-->
        <!--  />-->
        <!--  <div class="m-t-24 m-b-16">登录后查看更多商机</div>-->
        <!--  <a-button type="primary" style="width: 120px" @click="login">-->
        <!--    立即登录-->
        <!--  </a-button>-->
        <!--</div>-->
        <common-empty v-if="noticeList.length === 0" />
        <template v-else>
          <div class="notice-list">
            <notice-list-item
              v-for="item in noticeList"
              :key="item.noticeId"
              class="notice-list-item"
              :notice="getNotice(item)"
            />
          </div>
          <div class="text-center m-t-32">
            <a-button
              style="width: 176px; height: 40px"
              @click="toNetworkNotice"
            >
              查看更多
            </a-button>
          </div>
        </template>
      </div>

      <!-- 竞争对手分析-->
      <div v-if="showPortrait" id="competitor" class="competitor-section">
        <div class="section-header">竞争对手分析</div>
        <div class="section-body body-width">
          <el-tabs v-model="activeCompetitorDesc" stretch tab-position="left">
            <el-tab-pane
              v-for="item in competitorDescList"
              :key="item.name"
              :label="item.label"
              :name="item.name"
            >
              <div class="m-l-56">
                <div class="tab-title">{{ item.label }}</div>
                <el-divider />
                <div class="tab-desc">{{ item.desc }}</div>
                <img
                  class="tab-image m-t-24"
                  style="width: 892px"
                  :src="item.imgUrl"
                />
              </div>
            </el-tab-pane>
          </el-tabs>

          <div class="text-center m-t-40">
            <a-button
              type="primary"
              style="width: 176px; height: 40px"
              @click="toCompetitorAnalysis"
            >
              立即体验
            </a-button>
          </div>
        </div>
      </div>

      <!-- 采购单位分析-->
      <div v-if="showPortrait" id="purchaser" class="purchaser-section">
        <div class="section-header">采购单位分析</div>
        <div class="section-body body-width">
          <el-tabs v-model="activePurchaserDesc" stretch tab-position="left">
            <el-tab-pane
              v-for="item in purchaserDescList"
              :key="item.name"
              :label="item.label"
              :name="item.name"
            >
              <div class="m-l-56">
                <div class="tab-title">{{ item.label }}</div>
                <el-divider />
                <div class="tab-desc">{{ item.desc }}</div>
                <img
                  class="tab-image m-t-24"
                  style="width: 892px"
                  :src="item.imgUrl"
                />
              </div>
            </el-tab-pane>
          </el-tabs>

          <div class="text-center m-t-40">
            <a-button
              type="primary"
              style="width: 176px; height: 40px"
              @click="toPurchaserAnalysis"
            >
              立即体验
            </a-button>
          </div>
        </div>
      </div>
      <div id="contentBanner"></div>
      <!-- banner展示模块 -->
      <growth-publicity />
      <!-- 会员介绍模块 -->
      <members-publicity id="more" page="HomeView" style-model="home-style" />
    </div>
  </div>
</template>

<script>
// 组件
import SearchBox from '@/components/analysis/SearchBox'
import NoticeListItem from '@/components/common/NoticeListItem'
import CommonEmpty from '@/components/common/CommonEmpty'

import GrowthPublicity from '@/components/home/GrowthPublicity'
import MembersPublicity from '@/components/common/MembersPublicity'
// 字典
import { noticeResourceDict, noticeTypeDict } from '@/dictionary/common'

import { valueAddedProductCodeDict } from '@/dictionary/value-added'
// vuex
import { mapState } from 'vuex'
// 工具
import { toLogin, toVipBuy } from '@/utils/common'
// 接口
import { getNoticePageApi } from '@/api/notice'
import { getFollowedProjectPageApi } from '@/api/follow'

export default {
  name: 'HomeView',

  components: {
    SearchBox,
    NoticeListItem,
    CommonEmpty,
    GrowthPublicity,
    MembersPublicity
  },

  data() {
    return {
      // 关注的项目动态列表
      followProjectList: [],

      // 公告列表
      noticeList: [],

      // 当前选中的竞争对手分析内容
      activeCompetitorDesc: '',
      competitorDescList: [
        {
          label: '项目动态',
          name: '1',
          desc: '实时获取竞对企业中标、成交等信息，全面挖掘更多潜在商机，可按项目地区、行业、时间等多维度筛选商机项目，分析更有针对性',
          imgUrl:
            process.env.VUE_APP_OSS_URL +
            '/portal/static/image/vip/competitor-1.png'
        },
        {
          label: '年度项目统计',
          name: '2',
          desc: '跨年度统计竞对企业多年参与项目数量、规模，数据分析样本更精准，丰富的可视化图表，企业年度项目规模、增长趋势一目了然，迅速掌握业绩趋势',
          imgUrl:
            process.env.VUE_APP_OSS_URL +
            '/portal/static/image/vip/competitor-2.png'
        },
        {
          label: '重点合作客户',
          name: '3',
          desc: '打通全网和精彩纵横云采购平台真实采购交易数据，通过大数据分析，提供竞对企业重点客户列表，成交规模，日期等丰富信息，洞察竞对企业市场分布',
          imgUrl:
            process.env.VUE_APP_OSS_URL +
            '/portal/static/image/vip/competitor-3.png'
        },
        {
          label: '市场区域',
          name: '4',
          desc: '通过大数据分析，分析竞对企业的市场覆盖区域、提供竞争对手的中标项目量、规模等统计。',
          imgUrl:
            process.env.VUE_APP_OSS_URL +
            '/portal/static/image/vip/competitor-4.png'
        }
      ],

      // 当前选中的采购单位分析内容
      activePurchaserDesc: '',
      purchaserDescList: [
        {
          label: '采购单位通讯录',
          name: '1',
          desc: '整合全网资源及云采购平台历史交易数据，提取企业历史项目的全部联系人、联系方式，助力开发新客户',
          imgUrl:
            process.env.VUE_APP_OSS_URL +
            '/portal/static/image/vip/purchaser-1.png'
        },
        {
          label: '年度/月度项目统计',
          name: '2',
          desc: '对比采购单位近几年采购项目数量、金额，项目所在行业，采购趋势尽在掌握，整合采购单位历史项目，全面分析年度采购规划、项目预算，节资率，帮助投标人制定更有针对性的投标策略。',
          imgUrl:
            process.env.VUE_APP_OSS_URL +
            '/portal/static/image/vip/purchaser-2.png'
        },
        {
          label: '各类采购方式占比',
          name: '3',
          desc: '基于采购单位的历史项目招标方式，结合统计学分析，精准评估采购喜好；洞察采购单位招标方式、数量、金额占比，综合了解采购单位，帮企业决策是否投标',
          imgUrl:
            process.env.VUE_APP_OSS_URL +
            '/portal/static/image/vip/purchaser-3.png'
        },
        {
          label: '重点供应商',
          name: '4',
          desc: '按行业分析重点客户类型，综合评估采购单位的采购项目类型，分析行业市场趋势，帮助发掘客户和渠道；多维度交叉分析，提供重点及首次合作企业中标数量、中标金额、平均节支率、合作日期，直观了解采购单位与企业关系远近，辅助投标决策。',
          imgUrl:
            process.env.VUE_APP_OSS_URL +
            '/portal/static/image/vip/purchaser-4.png'
        }
      ]
    }
  },

  computed: {
    ...mapState('user', ['isLogin', 'vipInfo', 'isPortraitBtnShow']),

    // 是否显示毛玻璃蒙层
    showGlossy() {
      // 未登录或者非会员均要显示
      return !this.isLogin || this.showVipGlossy
    },

    // 是否显示高级会员毛玻璃蒙层
    showVipGlossy() {
      // 用户没有会员权限，或会员已过期，或会员等级为普通会员，均要展示
      return (
        !this.vipInfo.rightsId ||
        this.vipInfo.isExpire ||
        this.vipInfo.productInfo?.productCode ===
          valueAddedProductCodeDict.REGULAR_VIP.value
      )
    },

    showPortrait() {
      return false
    }
  },

  watch: {
    vipInfo: {
      handler(val) {
        if (!this.showVipGlossy) {
          this.getFollowProjectList()
        }
        // if (!val.rightsId) {
        //   // 不是会员，需要弹窗广告
        //   this.popupHandle()
        // }
      },
      deep: true
    }
  },

  created() {
    this.activeCompetitorDesc = this.competitorDescList[0].name
    this.activePurchaserDesc = this.purchaserDescList[0].name

    this.getNoticeList()
  },

  mounted() {
    // 从路由中获取要跳转的锚点id
    const target = this.$route.query.target
    this.$nextTick(() => {
      this.anchorJumps(target)
    })
  },

  methods: {
    handleSearch(keywords, routeName) {
      this.$router.push({
        name: routeName,
        query: { keywords: keywords }
      })
    },

    getNoticeTypeEntry(value) {
      return noticeTypeDict.translate(value) || {}
    },

    getFollowProjectList() {
      getFollowedProjectPageApi({ page: 1, size: 3 })
        .then((res) => {
          this.followProjectList = res.data.records || []
        })
        .catch((err) => {
          console.error('获取关注项目列表失败', err)
          if (err?.data?.message) this.$message.error(err.data.message)
        })
    },

    getNoticeList() {
      const params = {
        page: 1,
        size: 6
      }
      getNoticePageApi(params)
        .then((res) => {
          this.noticeList = res.data.records || []
        })
        .catch((err) => {
          console.error('获取公告列表失败', err)
          if (err?.data?.message) this.$message.error(err.data.message)
        })
    },

    getNotice(item) {
      // 需要根据sourceNoticeId区分公告来源
      const noticeSource = item.sourceNoticeId.split('_')[0]
      const noticeId =
        noticeSource === noticeResourceDict.JCZH.value.toString()
          ? item.sourceNoticeId.split('_')[1]
          : item.noticeId
      const categoryName =
        item.purchaseInfo?.purchaseCategories &&
        item.purchaseInfo?.purchaseCategories.length
          ? item.purchaseInfo?.purchaseCategories[0]?.categoryName
          : ''
      return {
        noticeId: noticeId,
        title: item.contentInfo?.title,
        province: item.purchaseInfo?.regionInfo.province,
        bidMethod: item.purchaseInfo?.bidMethod,
        budget: item.purchaseInfo?.budget,
        publishTime: item.publishTime,
        resource: noticeSource,
        purchaseId: item.purchaseId,
        categoryName: categoryName,
        purchaseName: item.purchaseInfo.purchaseInfo.purchaseName,
        url: item.url
      }
    },

    toProjectDetail(item) {
      this.$router.push({
        name: 'FollowProjectDetail',
        params: { purchaseId: item.purchaseId }
      })
    },

    toFollowProject() {
      this.$router.push({
        name: 'FollowProject'
      })
    },

    login() {
      toLogin()
    },

    handleVipBuy() {
      toVipBuy(this.$router)
    },

    toCompetitorAnalysis() {
      this.$router.push({
        name: 'CompetitorAnalysisList'
      })
    },

    toPurchaserAnalysis() {
      this.$router.push({
        name: 'PurchaserAnalysisList'
      })
    },

    // 锚点跳转
    anchorJumps(target) {
      if (!target) return
      const toElement = document.getElementById(target)
      const block = target === 'competitor' ? 'start' : 'center'
      toElement.scrollIntoView({ block })
    },

    /**
     * 前往全网商机搜索
     */
    toNetworkNotice() {
      this.$router.push({
        name: 'NetworkNotice'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  min-height: 100vh;

  .home-header {
    width: 100%;
    height: 400px;
    background: url('~@/assets/images/home/home-background.png') no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: $header-height;

    .home-header-title {
      font-size: 40px;
      color: $white-color;
      text-align: center;
      margin-bottom: 32px;
    }
  }

  .home-body {
    min-height: calc(100vh - 400px);
    display: flex;
    flex-direction: column;

    .follow-project-block {
      min-height: 160px;
      padding: 16px 24px;
      position: relative;

      .follow-project-block-title {
        color: $primary-color;
      }

      .more-button {
        color: $text-third-color;
        cursor: pointer;
      }

      ul {
        margin: 0;
        padding: 0;
        list-style-type: none;

        li {
          display: flex;
          align-items: center;

          &:before {
            content: '';
            width: 6px;
            height: 6px;
            display: inline-block;
            border-radius: 50%;
            background: $info-second-color;
            vertical-align: middle;
            margin-right: 7px;
          }

          &:not(:last-child) {
            margin-bottom: 16px;
          }
        }
      }

      .follow-title {
        cursor: pointer;

        &:hover {
          color: $primary-color;
        }
      }

      .notice-tag {
        color: $white-color;
        font-size: 12px;
        border-radius: 2px;
        padding: 2px 8px;
        margin-left: 8px;
        background: $primary-color;
        white-space: nowrap;

        &--warning {
          background: $warning-color;
        }
        &--info {
          background: $info-color;
        }
        &--danger {
          background: $danger-color;
        }
      }
    }

    .ad-block {
      border-radius: 4px;
      height: 104px;

      ::v-deep .slick-slide {
        height: 104px;
        line-height: 104px;
        background: #364d79;
        overflow: hidden;
        border-radius: 4px;

        h3 {
          color: #fff;
          text-align: center;
        }
      }

      .custom-slick-arrow {
        width: 25px;
        height: 25px;
        font-size: 25px;
        color: #fff;
        background-color: rgba(31, 45, 61, 0.11);
        opacity: 0.3;
      }

      .custom-slick-arrow:before {
        display: none;
      }

      .custom-slick-arrow:hover {
        opacity: 0.5;
      }
    }

    .notice-block {
      padding: 48px 24px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .notice-block-title {
        font-size: 28px;
      }

      .notice-list {
        width: $body-width;
        display: flex;
        flex-wrap: wrap;
        margin-top: 40px;

        .notice-list-item {
          width: calc((#{$body-width} - 40px) / 2);

          &:nth-child(odd) {
            margin-right: 40px;
          }
        }
      }
    }
  }
}

.g-glossy {
  position: absolute;
  width: $body-width;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  border-radius: 4px;
  color: $white-color;
  text-align: center;
  background-color: rgba(255, 255, 255, 1);
  backdrop-filter: blur(2px);

  &::before {
    content: unset;
  }

  @supports (background: -moz-element(#bg)) {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: -moz-element(#bg) no-repeat;
      filter: blur(10px);
      // filter: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='blur' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='8' edgeMode='duplicate'/%3E%3CfeComponentTransfer%3E%3CfeFuncA type='discrete' tableValues='0 1'/%3E%3C/feComponentTransfer%3E%3C/filter%3E%3C/svg%3E#blur");
      z-index: 5;
    }
  }
}

.login-tip-wrap,
.vip-tip-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .tip {
    color: $text-color;
    font-size: 18px;
  }
}

.vip-button {
  display: inline-block;
  padding: 6px 32px;
  border-radius: 4px;
  background: $member-sixth-color;
  color: $member-second-color;
  font-size: 14px;
  cursor: pointer;
}

.competitor-section {
  width: 100%;
  background: $white-color;
  position: relative;
  background: url('~@/assets/images/home/competitor-background.png') no-repeat;
  background-size: cover;
  padding-bottom: 48px;

  .section-header {
    font-size: 28px;
    color: $text-color;
    padding: 48px 0 32px;
    text-align: center;
  }

  .section-header,
  .section-body {
    position: relative;
    z-index: 2;
  }

  ::v-deep .el-tabs__item {
    padding: 0 40px;
    font-size: 18px;
    height: 56px;
    line-height: 56px;
    font-weight: normal;
  }

  ::v-deep .el-tabs__nav {
    height: 508px;
  }

  ::v-deep .el-tabs__nav-wrap::after {
    background-color: #d9d9d9;
  }

  .tab-title {
    font-size: 18px;
    color: $text-color;
  }

  .tab-desc {
    width: 829px;
    font-size: 14px;
    line-height: 24px;
    color: $text-second-color;
  }

  ::v-deep .el-divider--horizontal {
    margin: 16px 0;
    background: #d9d9d9;
    width: 829px;
  }
}

.purchaser-section {
  width: 100%;
  background: $white-color;
  position: relative;
  padding-bottom: 48px;

  .section-header {
    font-size: 28px;
    color: $text-color;
    padding: 48px 0 32px;
    text-align: center;
  }

  .section-header,
  .section-body {
    position: relative;
    z-index: 2;
  }

  ::v-deep .el-tabs__item {
    padding: 0 40px;
    font-size: 18px;
    height: 56px;
    line-height: 56px;
    font-weight: normal;
  }

  ::v-deep .el-tabs__nav {
    height: 432px;
  }

  ::v-deep .el-tabs__nav-wrap::after {
    background-color: #d9d9d9;
  }

  .tab-title {
    font-size: 18px;
    color: $text-color;
  }

  .tab-desc {
    width: 829px;
    line-height: 24px;
    font-size: 14px;
    color: $text-second-color;
  }

  ::v-deep .el-divider--horizontal {
    margin: 16px 0;
    background: #d9d9d9;
    width: 829px;
  }
}
</style>
